var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-knowledge-box",
      attrs: { id: "search-knowledge-box" }
    },
    [
      _c("div", { staticClass: "search-input-box flexBox" }, [
        _c(
          "div",
          {
            staticClass: "topic-select",
            on: {
              click: function($event) {
                _vm.topicSelected = true
              }
            }
          },
          [_vm._v(_vm._s(_vm.selectedTopic)), _c("i")]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "search-box",
            attrs: { action: "#" },
            on: {
              submit: function($event) {
                $event.preventDefault()
              },
              click: function($event) {
                return _vm.$refs.searchinput.focus()
              }
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keywords,
                  expression: "keywords"
                }
              ],
              ref: "searchinput",
              staticClass: "search-input",
              attrs: {
                type: "search",
                maxlength: "50",
                placeholder: _vm.placeholder
              },
              domProps: { value: _vm.keywords },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.getSearch($event)
                },
                focus: _vm.searchFocus,
                blur: _vm.SearchBlur,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.keywords = $event.target.value
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "i",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.keywords,
                expression: "keywords"
              }
            ],
            staticClass: "icon icon-searchClose search-close",
            on: { click: _vm.ClearSearch }
          },
          [
            _c("span", { staticClass: "path1" }),
            _c("span", { staticClass: "path2" })
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "search-btn",
            class: { "search-btn-disabled": !_vm.keywords },
            on: { click: _vm.getSearch }
          },
          [_vm._v("搜索")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.actionSearch && false,
              expression: "!actionSearch && false"
            }
          ],
          staticClass: "search-knowledge-tip padding-sets"
        },
        [
          _c("p", { staticClass: "tip-head" }, [_vm._v("提示")]),
          _vm._v(" "),
          _c("span", { staticClass: "tip-content" }, [
            _vm._v(
              "可以通过关键词搜索和一线服务、销售、日常办公相关的蔚来知识及常见问题"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "topic-select-mask-anim" } }, [
        _vm.topicSelected
          ? _c("div", {
              staticClass: "topic-select-mask",
              on: {
                click: function($event) {
                  _vm.topicSelected = false
                }
              }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "topic-select-list-wrapper-anim" } }, [
        _vm.topicSelected
          ? _c(
              "div",
              {
                staticClass: "topic-select-list-wrapper",
                on: {
                  touchstart: function($event) {
                    return _vm.$refs.searchinput.blur()
                  }
                }
              },
              [
                _c("h5", { staticClass: "topic-head padding-sets" }, [
                  _vm._v("搜索指定内容"),
                  _c("i", {
                    staticClass: "close-icon",
                    on: {
                      click: function($event) {
                        _vm.topicSelected = false
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list-wrapper padding-sets" }, [
                  _c(
                    "div",
                    { staticClass: "topic-lists" },
                    _vm._l(_vm.scopeLists, function(scope) {
                      return _c("span", {
                        key: scope.NodeId,
                        staticClass: "topic-list-item flexBox",
                        class: {
                          "topic-list-item-active":
                            scope.NodeId == _vm.selectNodeId ||
                            (!scope.NodeId && !_vm.selectNodeId)
                        },
                        domProps: { textContent: _vm._s(scope.Name) },
                        on: {
                          click: function($event) {
                            return _vm.selectTopic(scope)
                          }
                        }
                      })
                    }),
                    0
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.actionSearch && _vm.searchHistoryList.length
        ? _c("div", { staticClass: "search-history" }, [
            _c("h5", { staticClass: "history-head" }, [
              _vm._v("搜索历史"),
              _c("i", {
                staticClass: "clear-icon",
                on: { click: _vm.clearSearchHistory }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "history-list" },
              _vm._l(_vm.searchHistoryList, function(historys) {
                return _c("span", {
                  staticClass: "history-list-item",
                  domProps: { textContent: _vm._s(historys) },
                  on: {
                    click: function($event) {
                      return _vm.searchingHistory(historys)
                    }
                  }
                })
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.similarWordList.length
        ? _c(
            "div",
            { staticClass: "search-result search-advice padding-sets" },
            [
              _vm._v("\n        猜你想搜"),
              _vm._l(_vm.similarWordList, function(similarWord, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    on: {
                      click: function($event) {
                        return _vm.Searching(similarWord)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        similarWord +
                          (index === _vm.similarWordList.length - 1 ? "" : "，")
                      )
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c(
            "div",
            { staticClass: "search-result search-atlas-result padding-sets" },
            [
              _c("div", {
                staticClass: "atlas",
                domProps: { innerHTML: _vm._s(_vm.atlas) }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "thumb-up-down", class: _vm.userAction },
                [
                  _c(
                    "div",
                    {
                      staticClass: "thumb-up",
                      on: {
                        click: function($event) {
                          return _vm.recommandThumUpDown(true)
                        }
                      }
                    },
                    [_c("i"), _c("span", [_vm._v("有用")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "thumb-down",
                      on: {
                        click: function($event) {
                          return _vm.recommandThumUpDown(false)
                        }
                      }
                    },
                    [_c("i"), _c("span", [_vm._v("没用")])]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.knowledgeListLength,
              expression: "knowledgeListLength"
            }
          ],
          staticClass: "search-result search-knowledge-result padding-sets"
        },
        [
          _c(
            "p",
            {
              staticClass: "search-total fellow-total search-bdr flexBox",
              class: {
                "click-diable": _vm.knowledgeListLength <= _vm.knowledgeMax
              },
              on: { click: _vm.viewKnowledgeList }
            },
            [
              _c("span", { staticClass: "flexItem" }, [
                _vm._v("知识点(" + _vm._s(_vm.knowledgeListLength) + ")")
              ]),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.knowledgeListLength > _vm.knowledgeMax,
                    expression: "knowledgeListLength > knowledgeMax"
                  }
                ],
                staticClass: "arrowImg",
                attrs: { src: "/static/images/arrawRight.png", alt: "" }
              })
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.knowledgeList, function(knowledge, index) {
            return index < _vm.knowledgeMax
              ? _c(
                  "section",
                  {
                    staticClass: "knowledge-list box_search",
                    class: _vm.$style["box_search"],
                    on: {
                      click: function($event) {
                        return _vm.viewKnowledge(knowledge.KBInfoId, index)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "search-item-title",
                      domProps: { innerHTML: _vm._s(knowledge.Title) }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "search-item-content",
                      domProps: { innerHTML: _vm._s(knowledge.Content) }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "analyse-info" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("validCount")(knowledge.TotalViewCount)
                          ) + "人浏览"
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-10" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("validCount")(knowledge.TotalCollectionCount)
                          ) + "人收藏"
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.faqListLength,
              expression: "faqListLength"
            }
          ],
          staticClass: "search-result search-faq-result padding-sets"
        },
        [
          _c(
            "p",
            {
              staticClass: "search-total faq-total search-bdr flexBox",
              class: { "click-diable": _vm.faqListLength <= _vm.faqMax },
              on: { click: _vm.viewFAQList }
            },
            [
              _c("span", { staticClass: "flexItem" }, [
                _vm._v("常见问题(" + _vm._s(_vm.faqListLength) + ")")
              ]),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.faqListLength > _vm.faqMax,
                    expression: "faqListLength > faqMax"
                  }
                ],
                staticClass: "arrowImg",
                attrs: { src: "/static/images/arrawRight.png" }
              })
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.faqList, function(faq, index) {
            return index < _vm.faqMax
              ? _c(
                  "section",
                  {
                    staticClass: "faq-list box_search",
                    class: _vm.$style["box_search"],
                    on: {
                      click: function($event) {
                        return _vm.viewFAQ(faq.KBInfoId, index)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "search-item-title",
                      domProps: { innerHTML: _vm._s(faq.Title) }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "search-item-content",
                      domProps: { innerHTML: _vm._s(faq.Content) }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "analyse-info" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("validCount")(faq.TotalViewCount)) +
                            "人浏览"
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-10" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("validCount")(faq.TotalCollectionCount)
                          ) + "人收藏"
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.attachmentListLength,
              expression: "attachmentListLength"
            }
          ],
          staticClass: "search-result search-attachments-result padding-sets"
        },
        [
          _c(
            "p",
            {
              staticClass:
                "search-total faq-total search-bdr flexBox attachment-border",
              class: {
                "click-diable": _vm.attachmentListLength < _vm.attachmentMax
              },
              on: { click: _vm.viewAttachmentList }
            },
            [
              _c("span", { staticClass: "flexItem" }, [
                _vm._v("附件(" + _vm._s(_vm.attachmentListLength) + ")")
              ]),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.attachmentListLength >= _vm.attachmentMax,
                    expression: "attachmentListLength >= attachmentMax"
                  }
                ],
                staticClass: "arrowImg",
                attrs: { src: "/static/images/arrawRight.png" }
              })
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.attachmentList, function(attachment, index) {
            return index < _vm.attachmentMax
              ? _c(
                  "section",
                  {
                    staticClass: "attachment-list box_search ",
                    class: _vm.$style["box_search"],
                    on: {
                      click: function($event) {
                        return _vm.attachmentVisited(index)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "search-list-item",
                        on: {
                          click: function($event) {
                            return _vm.openFile(attachment.Url, attachment.Name)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "attachment-link" }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "attachment-content",
                          class: {
                            "attchment-visited": attachment.visited == true
                          },
                          domProps: { innerHTML: _vm._s(attachment.Name) }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.unSatisfyTip,
              expression: "unSatisfyTip"
            }
          ],
          staticClass: "search-noresult-tip"
        },
        [
          _c("div", { staticClass: "noresult" }),
          _vm._v(" "),
          _c("span", [_vm._v("没找到想要的内容?")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "noresult-text",
              on: {
                click: function($event) {
                  return _vm.actionSeekHelp("Search")
                }
              }
            },
            [_vm._v("求助")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-f898f72e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f898f72e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/search/searchKnowledge.vue
// module id = Hs6e
// module chunks = 2